import React from 'react';
import { faCaretLeft, faCaretRight } from '@fortawesome/free-solid-svg-icons';

import Button, { ButtonProps } from '../buttons/button';

export const PreviousButton = (props: Omit<ButtonProps, 'ref'>) => (
  <Button text="Previous" icon={faCaretLeft} slimButton {...props} />
);

export const NextButton = (props: Omit<ButtonProps, 'ref'>) => (
  <Button text="Next" alignIconRight icon={faCaretRight} slimButton {...props} />
);
